import React from 'react';
import { Link } from 'react-router-dom';
import SellWiseLogo from '../assets/sellwise-logo.png';

const Header = () => {
  return (
    <header className="header">
      <div className="container header-container">
        <Link to="/" className="logo">
          <img src={SellWiseLogo} alt="SellWise Logo" height="40" />
         
        </Link>
        <nav>
          <ul>
            <li><a href="#features">Features</a></li>
            {/* <li><a href="#solutions">Solutions</a></li> */}
            <li><a href="#how-it-works">How It Works</a></li>
            {/* <li><Link to="#clients">Clients</Link></li> */}
            <li><a href="#contact">Contact</a></li>
            <li><a href="#demo" className="cta-button">Request Demo</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;